import { render } from "./TransaccionShow.vue?vue&type=template&id=e8a602ae"
import script from "./TransaccionShow.vue?vue&type=script&lang=js"
export * from "./TransaccionShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__